import { Component, ElementRef, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fic-screen-content',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fic-screen-content.component.scss'],
    host: { class: 'fic-screen-content' },
    standalone: false,
})
export class FicScreenContentComponent {
    constructor(public elRef: ElementRef<HTMLElement>) {}
}
